import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import { asyncComponent } from 'react-async-component';

import {fetchEvent, setEventData} from '@/actions/event';
import { setConfirmation, setApiUrl, setListingSlug, resetUi, setCheckoutConfig} from '@/actions/ui';
import {StyleContext} from '@c/StyleContext';
import {CurrencyContext} from '@c/CurrencyContext';
import Translations from '@h/translation';
import {TranslationContext} from '@c/Translations';
import Listing from './containers/Listing';
import { toUrlParams } from '@h/helpers';
import { setListingConfig, setDefaultShowCalendarInModal, setShowCalendarInModal } from '@/actions/ui';
import { validatePresaleCoupon, getHiddenPriceLevels } from 'checkout/views/coupon/actions/coupon';
import { getEventSeriesChildListing, setWidth } from 'checkout/views/series/actions/event-series';
import { getBlockingErrors, isKioskMode, getCmsMode } from 'checkout/selectors/ui';
import Notification from './components/Notification';
import { getListingItem } from './helpers/storage';
import { setEmailOptOut, setDefaultEmailOptOut } from 'checkout/views/member/actions/member';
import InteractionBlock from 'checkout/containers/InteractionBlock';
import KioskLoginContainer from './views/kiosk-management/containers/KioskLoginContainer';
import { setKioskToken, KIOSK_AUTH_TOKEN } from './views/kiosk-management/actions/kiosk-management';
import { CustomerCareHeader } from './components/CustomerCareHeader.tsx';

const AsyncCheckout = asyncComponent({
    resolve: () => import('../checkout/containers/CheckoutContainer'),
});

class App extends Component {
    stripeTerminal = null;
    t = null;

    constructor(props) {
        super(props);

        this.t = new Translations(this.props.apiUrl);
        this.t.init('en_US');
    }

    // ignoring the passed error and info, rollbar will pick them up
    componentDidCatch(error, info) {
        if(this.props.errorHandler) {
            this.props.errorHandler();
        }
    }

    componentDidMount() {
        this.props.resetUi();
        this.props.setApiUrl(this.props.apiUrl);
        this.props.setListingSlug(this.props.listingSlug);
        if (window && window.innerWidth) {
            this.props.setWidth(window.innerWidth);
        }

        if(Object.keys(this.props.listingData).length !== 0) {
            this.props.setEventData(this.props.listingData);
        }

        if(this.props.listingConfig.checkout) {
            this.props.setCheckoutConfig(this.props.listingConfig.checkout);
            if (this.props.listingConfig.checkout.seriesOptions && this.props.listingConfig.checkout.seriesOptions.calendarOnListing) {
                this.props.setDefaultShowCalendarInModal(false);
                this.props.setShowCalendarInModal(false);
            }
        }

        if(this.props.listingConfig && Object.keys(this.props.listingConfig).length > 0) {
            this.props.setListingConfig(this.props.listingConfig);
            this.props.setDefaultEmailOptOut(this.props.listingConfig.opt_out_by_default);
            this.props.setEmailOptOut(this.props.listingConfig.opt_out_by_default);
        }

        this.props.setConfirmation(false);

        if (this.props.coupon.presaleCode !== "" && this.props.coupon.isPresaleValid === true && this.props.coupon.isPresaleCodeApplied === true) {
            this.props.validatePresaleCoupon(true);
        }

        if (getListingItem(this.props.listingSlug, 'selectedEventId')) {
            this.props.getEventSeriesChildListing(getListingItem(this.props.listingSlug, 'selectedEventId'));
        }

        if (this.props.coupon.accessCode !== "" && this.props.coupon.isAccessCodeValid === true && this.props.coupon.isAccessCodeApplied === true) {
            this.props.getHiddenPriceLevels();
        }

        let kioskAuthToken = getListingItem(this.props.listingSlug, KIOSK_AUTH_TOKEN);
        if (kioskAuthToken) {
            this.props.setKioskToken(kioskAuthToken);
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.listingConfig !== this.props.listingConfig) {
            this.props.setListingConfig(this.props.listingConfig);
            this.props.setCheckoutConfig(this.props.listingConfig.checkout);
        }
    }

    render() {
        let params = toUrlParams(this.props.uiConfig);

        let cssUrl = "";
        if(this.props.uiConfig.siteCss) {
            cssUrl = this.props.uiConfig.siteCss[this.props.uiConfig.layout];
        }

        if(this.props.checkoutConfig && Object.keys(this.props.checkoutConfig).length > 0) {
            return(
                <TranslationContext.Provider value={this.t}>
                    <StyleContext.Provider value={this.props.styleVars}>
                        <CurrencyContext.Provider value={this.props.currencyConfig}>
                            {(this.props.uiConfig.layout && !this.props.uiConfig.skipListingCss) && <link rel="stylesheet" href={cssUrl} />}
                            {(this.props.styleVars && !this.props.uiConfig.skipListingCss) && <link rel="stylesheet" href={this.props.listingData.sassUrl+"/"+this.props.uiConfig.layout+"/skin.css?"+params} />}
                            <div id="mangement-access-div"></div>
                            <div id="kiosk__management"></div>
                            <div id="help"></div>
                            {this.props.blockingErrors.length > 0 && <Notification messages={this.props.blockingErrors}/>}
                            <div id="timeout-overlay"></div>
                            <ConfiguredListing config={this.props.checkoutConfig.listing}/>
                            <AsyncCheckout router={this.props.router} store={this.props.store} apiUrl={this.props.apiUrl} listingConfig={this.props.listingConfig}/>
                        </CurrencyContext.Provider>
                    </StyleContext.Provider>
                </TranslationContext.Provider>
            )
        }

        return(
            <TranslationContext.Provider value={this.t}>
                <StyleContext.Provider value={this.props.styleVars}>
                    <CurrencyContext.Provider value={this.props.currencyConfig}>
                        {(this.props.uiConfig.layout && !this.props.uiConfig.skipListingCss) && <link rel="stylesheet" href={cssUrl} />}
                        {(this.props.styleVars && !this.props.uiConfig.skipListingCss) && <link rel="stylesheet" href={this.props.listingData.sassUrl+"/"+this.props.uiConfig.layout+"/skin.css?"+params} />}
                        {this.renderListing()}
                    </CurrencyContext.Provider>
                </StyleContext.Provider>
            </TranslationContext.Provider>
        )
    }

    renderListing = () => {
        // maybe these named divs should be portaled
        return(
            <Fragment>
                <div id="mangement-access-div"></div>
                <div id="kiosk__management"></div>
                <InteractionBlock />
                {this.props.blockingErrors.length > 0 && <Notification messages={this.props.blockingErrors}/>}
                <div id="kiosk__time__container"></div>
                <CustomerCareHeader {...(this.props.uiConfig.customerCare || {})} />
                {(this.props.isKiosk && !this.props.kioskToken && !this.props.cmsMode) ? <KioskLoginContainer /> : <Listing />}
                <AsyncCheckout router={this.props.router} store={this.props.store} apiUrl={this.props.apiUrl} listingConfig={this.props.listingConfig}/>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        styleVars: state.ui.styleVars,
        uiConfig: state.ui.uiConfig,
        currencyConfig: state.ui.currencyConfig,
        coupon: state.coupon,
        blockingErrors: state.kioskManagement.token ? getBlockingErrors(state) : [],
        sellerId: state.event.seller_id,
        isKiosk: isKioskMode(state),
        kioskToken: state.kioskManagement.token,
        cmsMode: getCmsMode(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        fetchEvent,
        setConfirmation,
        setApiUrl,
        setListingSlug,
        setListingConfig,
        resetUi,
        setEventData,
        validatePresaleCoupon,
        getEventSeriesChildListing,
        getHiddenPriceLevels,
        setCheckoutConfig,
        setEmailOptOut,
        setDefaultEmailOptOut,
        setDefaultShowCalendarInModal,
        setShowCalendarInModal,
        setKioskToken,
        setWidth,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
